/**
 * 臻有钱-品质首页- 轮播banner显示 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱首页-首页滚动banner
 * uuid:cc5feae3c4ed4719873c8deff3986c9a
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import AdvCommonContainer from '../adv-common-container';
import { AdvEvent } from '../types';
import style from './index.module.scss';

 @Component
export default class AdvBanners extends Vue {
  @Prop({ default: '' })
  private customClassName!: string;

  /** 点击埋点 */
  private ubtClickTrack(event:AdvEvent) {
    const { item } = event.data.dataset || {};
    this.$ubtPageButton('finance_qualityHomePage_Zbanner',
      'buttonName',
      item.tracker.child_task_name);
  }

  private render() {
    return (
      <AdvCommonContainer
        advMasterId="cc5feae3c4ed4719873c8deff3986c9a"
        onClickEmitter={this.ubtClickTrack.bind(this)}
        needConfirmFinanceAgreements={false}
        customClassName={[this.customClassName, style.bannerList]}
      />
    );
  }
}
